import React from 'react';

type FileTextRoundIconProps = React.SVGProps<SVGSVGElement>;

export const FileTextRoundIcon: React.FC<FileTextRoundIconProps> = (props) => (
  <svg
    width="46"
    height="46"
    viewBox="0 0 46 46"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    {...props}>
    <rect x="3" y="3" width="40" height="40" rx="20" fill="#F4EBFF" />
    <rect x="3" y="3" width="40" height="40" rx="20" stroke="#F9F5FF" strokeWidth="6" />
    <path
      d="M24.6663 14.6667H17.9997C17.5576 14.6667 17.1337 14.8423 16.8212 15.1549C16.5086 15.4675 16.333 15.8914 16.333 16.3334V29.6667C16.333 30.1088 16.5086 30.5327 16.8212 30.8453C17.1337 31.1578 17.5576 31.3334 17.9997 31.3334H27.9997C28.4417 31.3334 28.8656 31.1578 29.1782 30.8453C29.4907 30.5327 29.6663 30.1088 29.6663 29.6667V19.6667M24.6663 14.6667L29.6663 19.6667M24.6663 14.6667V19.6667H29.6663M26.333 23.8334H19.6663M26.333 27.1667H19.6663M21.333 20.5001H19.6663"
      stroke="#7F56D9"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

FileTextRoundIcon.displayName = 'FileTextRoundIcon';

export default FileTextRoundIcon;
